import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getPerformance } from 'firebase/performance';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { FIREBASE_CONFIG } from './config';

// Validate required environment variables
const requiredEnvVars = [
  'REACT_APP_FIREBASE_API_KEY',
  'REACT_APP_FIREBASE_AUTH_DOMAIN',
  'REACT_APP_FIREBASE_PROJECT_ID',
  'REACT_APP_FIREBASE_STORAGE_BUCKET',
  'REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
  'REACT_APP_FIREBASE_APP_ID',
];

const missingVars = requiredEnvVars.filter((varName) => !process.env[varName]);
if (missingVars.length > 0) {
  throw new Error(`Missing required environment variables: ${missingVars.join(', ')}`);
}

// Initialize Firebase
const firebaseApp = initializeApp(FIREBASE_CONFIG);

// Initialize services
const db = getFirestore(firebaseApp);
const auth = getAuth(firebaseApp);
const provider = new GoogleAuthProvider();

// Initialize analytics and performance (optional)
let analytics = null;
let perf = null;

isSupported().then((yes) => {
  if (yes) {
    analytics = getAnalytics(firebaseApp);
  }
});

try {
  perf = getPerformance(firebaseApp);
} catch (error) {
  // Performance monitoring not available in this environment
}

// Initialize functions
const functions = getFunctions(firebaseApp);

export { db, analytics, perf, auth, provider, functions };
export default firebaseApp;
